import { db } from "../firebaseClient"
import { doc, getDoc } from "firebase/firestore"

// Client-side mirror of the Firestore rules' isPlatformAdmin() check — rules
// are the real security boundary (this can't be trusted for data access),
// but the UI needs its own check to decide whether to render the Control
// Plane at all, rather than rendering it for anyone and letting every read
// silently fail.
export const checkIsPlatformAdmin = async (uid) => {
  if (!uid) return { isAdmin: false, error: null }
  try {
    const snap = await getDoc(doc(db, "platformAdmins", uid))
    return { isAdmin: snap.exists(), error: null }
  } catch (error) {
    return { isAdmin: false, error }
  }
}